import { AssistantCodeBlock } from './AssistantCodeBlock';
import {
  AssistantMDTable,
  MarkdownSpan,
  MarkdownTbody,
  MarkdownTd,
  MarkdownTh,
  MarkdownThead,
  MarkdownTr,
} from './AssistantMDTable';
import { MarkdownLink } from './MarkdownLink';
import { MarkdownParagraph } from './MarkdownParagraph';

export const markdownComponents = {
  a: MarkdownLink,
  p: MarkdownParagraph,
  span: MarkdownSpan,
  pre: AssistantCodeBlock,
  table: AssistantMDTable,
  thead: MarkdownThead,
  tbody: MarkdownTbody,
  tr: MarkdownTr,
  th: MarkdownTh,
  td: MarkdownTd,
};
